import { lazy } from 'react';

import ROUTE_CONSTANTS from '../RouteConstants';

const SinglePageLogin = lazy(() => import ('../../../../auth/containers/SinglePageLogin'))

export const getPublicRoutes = () => [
  {
    path: ROUTE_CONSTANTS.LOGIN,
    component: SinglePageLogin,
    exact: true,
    isAuthorized: () => true
  }
];
